export const productionLocales = ["en", "fr"] as const;
export type ProductionLocale = (typeof productionLocales)[number];

export const defaultLocale = "en" satisfies ProductionLocale;
export const testLocale = "en-Test-CA" as const;

export type TestLocale = typeof testLocale;
export type Locale = ProductionLocale | TestLocale;

export const localeDisplayNames = {
	en: "English",
	fr: "Français",
	[testLocale]: "Test Blocks",
} satisfies Record<Locale, string>;

export function getLocaleDisplayName(locale: Locale): string {
	return localeDisplayNames[locale];
}

export function getLocalesForEnvironment(
	nodeEnv: string | undefined = process.env.NODE_ENV,
) {
	return nodeEnv === "development"
		? [...productionLocales, testLocale]
		: productionLocales;
}
